/** The Info tab (unit convention §1). */
import React from 'react';

import {useInfoPanelModel} from './model';
import InfoPanelView from './View';

export default React.memo(function InfoPanel() {
  return <InfoPanelView {...useInfoPanelModel()} />;
});
